import React from 'react';
import { Box, Typography } from '@mui/material';
import UsuarioVisualizar from '../components/usuario/UsuarioVisualizar';

const UsuarioVisualizarPage: React.FC = () => {
  return (
    <Box>
      <Typography 
        variant="h4" 
        component="h1" 
        gutterBottom 
        sx={{ 
          fontWeight: 'bold',
          fontFamily: 'Arial, sans-serif',
          fontSize: '2.125rem',
          lineHeight: 1.235
        }}
      >
        Visualizar Usuário
      </Typography>
      <UsuarioVisualizar />
    </Box>
  );
};

export default UsuarioVisualizarPage;
